/* eslint-disable no-unreachable */
export const creativesActions = {
	"SORTING": "SORTING",
	"FILTERING": "FILTERING",
	"INIT": "INIT"
};

/**
 * Init items
 * @param {array} creatives
 * @param {object} meta
 * @param {number} meta.total_count
 * @param {number} meta.total
 * @param state
 * @return {object} new state
 */
const initItems = (creatives, meta, state) => {
	// rebuild campaign request in according to UI necessity
	state.pager.setTotal(meta);

	return {
		...state,
		creatives
	}
};

export const creativeGridReducer = (state, action) => {
	switch(action.type) {
		case(creativesActions.INIT):
			return initItems(action.data, action.pager, state);

		default:
			throw new Error("Method is not implement");
	}
};